import React, { useContext } from "react";
import whatsappgif from "../../assets/images/icons/whatsapp1.webp";
import "./FloatingIcon.scss";
import { MapContext } from "../../context/MapContext";
import { brandData } from "../../utils/constants";

const FloatingIcon = () => {
  const { mapValue } = useContext(MapContext);

  return (
    <div className="floating_icon_wrape">
      <a
        href={`https://wa.me/${brandData.find((item) => item.slug === mapValue).whatsapp}`}
        className="contact-pannel-btn text-decoration-none"
        target={"_blank"}
      >
        <figure>
          <img src={whatsappgif} loading="lazy" alt="whatsapp" />
        </figure>
      </a>
    </div>
  );
};

export default FloatingIcon;
